module.exports = __webpack_public_path__ + "img/red.476a4045.jpg";